'use strict';
import angular from 'angular';
import FooterController from './footer.component';
export default angular.module('directives.footer', [])
    .controller('FooterController', FooterController)
    .component('footer', {
    template: require('./footer.html'),
    controller: FooterController
})
    .run(function ($rootScope) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
        //document.getElementById('ee-chat').style.bottom = "0";
        var currentState = next.name;
        var footer = document.getElementById('footer') || {};
        var classList = footer.classList || { add: function () { }, remove: function () { } };
        //var eeChat = document.getElementById('ee-chat');
        //var zChat = document.getElementsByClassName('express-checkout-wrapper')[0];
        if (currentState == 'placedOrder') {
            classList.add("print-order-mode");
        }
        else {
            classList.remove("print-order-mode");
        }
        if (currentState == 'cart' ||
            currentState == 'shippingAndDelivery' ||
            currentState == 'payment' ||
            currentState == 'reviewOrder') {
            classList.add("padding");
        }
        else {
            classList.remove("padding");
        }
    });
})
    .name;
//# sourceMappingURL=index.js.map